export default {
    state: () => {
        return {
            SocketUserId: 2,
            newNotification:null
        };
    },
    getters: {
        SocketId(state) {
            return state.SocketUserId;
        },
        getNewNotification(state) {
            return state.newNotification;
        }
    },
    mutations: {
        SetDefaultSocketId(state) {
            state.SocketUserId = 0;
        },
        sendMessage(state, resultId) {
            state.SocketUserId = resultId;
        },
        setNewNotification(state,data){
state.newNotification = data
        }
    },
    actions: {

    },
};